interface AppConfig {
  API_URL: string;
  KB_API_URL: string;
  CONVERSE_API_URL: string;
  ADMIN_API_URL: string;
  USER_POOL_ID: string;
  USER_POOL_CLIENT_ID: string;
  USER_POOL_CLIENT_LOCAL_ID?: string;
  USER_POOL_DOMAIN: string;
  AWS_REGION: string;
  DISCORD_CLIENT_ID?: string;
}

declare global {
  interface Window {
    APP_CONFIG?: AppConfig;
  }
}

const getConfig = (): AppConfig => {
  let rawConfig: AppConfig;
  
  // Check if runtime config exists (production/S3)
  if (window.APP_CONFIG) {
    rawConfig = window.APP_CONFIG;
  } else {
    // Fallback to env vars for local development
    rawConfig = {
      API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3000',
      KB_API_URL: process.env.REACT_APP_KB_API_URL || 'http://localhost:3000',
      CONVERSE_API_URL: process.env.REACT_APP_CONVERSE_API_URL || 'http://localhost:3000',
      ADMIN_API_URL: process.env.REACT_APP_ADMIN_API_URL || 'http://localhost:3000',
      USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID || '',
      USER_POOL_CLIENT_ID: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
      USER_POOL_DOMAIN: process.env.REACT_APP_COGNITO_DOMAIN || '',
      AWS_REGION: process.env.REACT_APP_AWS_REGION || 'us-east-1',
    };
  }
  
  // Detect if running locally
  const isLocalhost = window.location.hostname === 'localhost' || 
                     window.location.hostname === '127.0.0.1';
  
  // Choose the appropriate client ID based on environment
  const clientId = isLocalhost && rawConfig.USER_POOL_CLIENT_LOCAL_ID 
    ? rawConfig.USER_POOL_CLIENT_LOCAL_ID 
    : rawConfig.USER_POOL_CLIENT_ID;
  
  return {
    ...rawConfig,
    USER_POOL_CLIENT_ID: clientId
  };
};

export const config = getConfig();
export default config;